import axios from "axios";
import AuthService from "../../services/login/auth.service";
import { cuentas, comprobantes } from "../../components/generico/utils/UrlAPI";

 
 //var idPersona = AuthService.getSocio()===undefined ? "-":AuthService.getSocio().idPersona.trim();
//var idPersona ="0";
 
class HabilitarCuentasService {
  async obtenerListadoCuentasAhorro() {
    var config = {
      method: "get",
      url:
      cuentas + "autogestion",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + AuthService.getCurrentToken(),
        },
    };

    return await axios(config);
  }

  async aperturaCuentaAhorro(idMoneda,sucursal) {
    var data = JSON.stringify({
      //idPersona: idPersona,
      idMoneda: idMoneda,
      // opcion: "C",
      canal: "WEB",
      sucursal:sucursal
    });

    var config = {
      method: "post",
      url:
      cuentas + "autogestion",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async descagarComprobante(titulo, nroOperacion, nombreSocio, nroSocio, cuenta, modalidad, tipoOperacion, moneda,sucursal) {
    
    var _url = comprobantes + "comprobantes/v2/apertura-caja-ahorro";

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nombre: nombreSocio,
      nroSocio: nroSocio,
      cuentaAhorro: cuenta,
      modalidad: modalidad,
      tipoOperacion: tipoOperacion,
      moneda: moneda,
      sucursal:sucursal
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  
  }
}
export default new HabilitarCuentasService();
